(function () {
  'use strict';
  var hostSelector = 'a, button, article, li, div, section, aside, form, label, summary, [role="button"]';
  var transportSelector = '.slick-track, .slick-slide, .swiper-wrapper, .swiper-slide, [data-carousel-track], [data-review-track], [data-reels-track]';

  function initialize(root) {
    if (!document.body.classList.contains('template-index')) return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('picture, img, video, svg').forEach(function (visual) {
      if (visual.closest('.lukzer-category-section')) return;
      if (visual.tagName === 'IMG' && visual.closest('picture')) return;
      if (visual.closest(transportSelector)) return;
      var host = visual.closest(hostSelector);
      if (!host || host === visual || host.classList.contains('lz-final-visual')) return;
      if (host.querySelector(':scope > .lz-final-visual')) return;
      host.classList.add('lz-final-host');
      visual.classList.add('lz-final-visual');
    });

    scope.querySelectorAll('a, button, [role="button"]').forEach(function (host) {
      if (host.closest('.lukzer-category-section')) return;
      if (host.closest(transportSelector) || host.querySelector(':scope > .lz-final-visual')) return;
      var visual = host.querySelector(':scope > span, :scope > i');
      if (!visual) return;
      host.classList.add('lz-final-host');
      visual.classList.add('lz-final-visual');
    });
  }

  function start() {
    initialize(document);
    if (!('MutationObserver' in window)) return;
    var frame = 0;
    new MutationObserver(function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        initialize(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
